import Injury from './Injury';

export default Injury;
